import {CustomFileType} from '../../../../service/file-upload/file-upload-type';
import {classNames} from '../../../../util/css';
import {UploadFileListItem} from '../upload-file-list-item/upload-file-list-item';

import * as styles from './upload-file-list.scss';

type PropsType = {
    fileList: Array<CustomFileType>;
    allowDownload?: boolean;
    onRemove?: (fileUid: string) => void;
    // Lets a caller adjust the list's own grid, e.g. a field holding a single file that reads better
    // as one full-width row.
    className?: string;
};

export function UploadFileList(props: PropsType): JSX.Element {
    const {fileList, allowDownload, onRemove, className} = props;

    return (
        <div className={classNames(styles.UploadFileList, className)}>
            {fileList.map((file) => {
                return (
                    <UploadFileListItem allowDownload={allowDownload} file={file} key={file.uid} onRemove={onRemove} />
                );
            })}
        </div>
    );
}
